"use client";
import {createContext, useEffect, useContext, useState} from "react";
import Lenis from "lenis";

export interface SmoothScrollContextType {
  lenis: {
    scrollTo: (
      target: string,
      options?: {
        duration?: number;
        easing?: (t: number) => number;
      },
    ) => void;
  } | null;
  scrollTo: (id: string) => void;
}

const SmoothScrollContext = createContext<SmoothScrollContextType>({
  lenis: null,
  scrollTo: () => {},
});

export function SmoothScrollProvider({children}: {children: React.ReactNode}) {
  const [lenis, setLenis] = useState<Lenis | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const lenisInstance = new Lenis({
        duration: 1.2,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });

      function raf(time: number) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);

      setLenis(lenisInstance);

      return () => lenisInstance.destroy();
    }
  }, []);

  return (
    <SmoothScrollContext.Provider
      value={{
        lenis,
        scrollTo: (id: string) => lenis?.scrollTo(`#${id}`),
      }}
    >
      {children}
    </SmoothScrollContext.Provider>
  );
}

export function useSmoothScroll() {
  return useContext(SmoothScrollContext);
}